import { BaseService } from '../../../http/BaseHttpService';
import { buildNexusUrl } from '../../../../features/utils/buildNexusUrl';
import {
    GenerateChatTitleRequest,
    GenerateChatTitleResponse,
    INexusChatTitleGenerationService,
} from '../interfaces/INexusChatTitleGenerationService';

interface NexusGenerateChatTitleApiResponse {
    title?: string;
}

export class NexusChatTitleGenerationService extends BaseService implements INexusChatTitleGenerationService {
    private readonly subscriptionKey = process.env.REACT_APP_NEXUS_APIM_SUBSCRIPTION_KEY ?? '';
    private readonly subKeyHeader = process.env.REACT_APP_NEXUS_APIM_KEY_HEADER_NAME ?? '';
    constructor(private readonly baseUrl: string) {
        super();
    }

    public async generateChatTitleAsync(
        request: GenerateChatTitleRequest,
        accessToken: string,
    ): Promise<GenerateChatTitleResponse> {
        const response = await this.getResponseAsync<NexusGenerateChatTitleApiResponse>(
            {
                url: buildNexusUrl(this.baseUrl, 'title-generation/generate'),
                method: 'POST',
                body: {
                    message: request.message,
                },
                headers: {
                    [this.subKeyHeader]: this.subscriptionKey,
                },
            },
            accessToken,
        );
        return {
            title: response.title ?? 'Error: Please contact the progpt team.',
        };
    }
}

export default NexusChatTitleGenerationService;
